import { DateBox, SelectBox } from 'devextreme-react'
import DataGrid, { Column } from 'devextreme-react/data-grid'
import _ from 'lodash'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import api from '../../../../services/api-configuration'
import { approveGroupage, assignTruck, cancelApproval, cancelGroupage, cancelTruckAssignment } from '../api'
import { Grupaj } from '../print/Grupaj'
import Irsaliye from '../print/Irsaliye'
import IslemlerEklePopup from './islemler-ekle-silme/IslemlerEklePopup'
import IslemlerSilmePopup from './islemler-ekle-silme/IslemlerSilmePopup'
import './styles.css'

const IslemlerPopup = ({
    groupageDetails,
    isOpen,
    setIsOpen,
    taseronData,
    contractData,
    detail,
    onFilter,
    groupageRef,
    saseEklemeRole,
    saseCikarmaRole
}) => {

    const [formData, setFormData] = useState({
        driver_name: '',
        driver_phone: '',
        plate_number: '',
        subcontractor_id: null,
        contract_owner_id: null,
        trailer_plate: '',
        create_user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
        groupage_no: groupageDetails?.groupage_no
    })
    const [modalOpen, setModalOpen] = useState({
        addModalOpen: false,
        deleteModalOpen: false
    });
    const [selectedChassis, setSelectedChassis] = useState(null);
    const [loading, setLoading] = useState(false);
    const refreshData = useCallback((clear) => {
        detail()
        if (clear) {
            setFormData({
                driver_name: '',
                driver_phone: '',
                plate_number: '',
                subcontractor_id: null,
                contract_owner_id: null,
                trailer_plate: '',
                create_user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
                groupage_no: groupageDetails?.groupage_no
            })
        }
    }, [groupageDetails?.groupage_no])


    useEffect(() => {
        if (groupageDetails) {
            // Eğer eşlenmiş tır yoksa ve contractor_id varsa, onu default olarak kullan
            const defaultSubcontractorId = !groupageDetails.plate_number && groupageDetails.contractor_id
                ? groupageDetails.contractor_id
                : groupageDetails.truck_subcontractor_id || null;

            setFormData({
                driver_name: groupageDetails.driver_name || '',
                driver_phone: groupageDetails.driver_phone || '',
                plate_number: groupageDetails.plate_number || '',
                subcontractor_id: defaultSubcontractorId,
                contract_owner_id: groupageDetails.contact_owner_id || null,
                trailer_plate: groupageDetails.trailer_number || ''
            })
        }
    }, [groupageDetails])

    const handleAddPopupOpen = () => {
        setModalOpen({
            addModalOpen: true,
            deleteModalOpen: false
        })
    }


    const handleDeletePopupOpen = (chassis) => {
        setSelectedChassis({
            ...chassis,
            groupage_no: groupageDetails.groupage_no
        })
        setModalOpen({
            addModalOpen: false,
            deleteModalOpen: true
        }
        )
    }
    const handlePopupClose = () => {
        setModalOpen({
            addModalOpen: false,
            deleteModalOpen: false
        })
        setSelectedChassis(null)

    }

    const handleGroupageEmpty = () => {
        // Grupajda şase kalmadığında çağrılır
        setModalOpen({
            addModalOpen: false,
            deleteModalOpen: false
        })
        setSelectedChassis(null)
        setIsOpen(prev => ({ ...prev, islemler: false }))
        onFilter() // getAllGroupages isteği atmak için
    }

    const handleSave = async (data) => {
        if (document.getElementById("save-button")) {
            document.getElementById("save-button").disabled = true
        }
        try {
            let body = {
                "groupage_no": groupageDetails?.groupage_no,
                "paper": document.getElementById("matbuNo").value,
                "seri_no": document.getElementById("seriNo").value,
                "contractor_id": document.getElementById("kontrat-sahibi-warning") ? groupageDetails?.subcontractor_id : parseInt(document.getElementById("konrat-sahibi").childNodes[0].childNodes[0].value),
                "subcontractor_id": formData.subcontractor_id || null
            }
            const response = await api.post("/updateDocuments", body);
            if (!response.data.success) toast.error(response.data.error.replace("ID", "") || "Grupaj Dökümanı güncellenemedi");
            else toast.success("Grupaj Dökümanı güncellendi");
        } catch (error) {
            console.error("Error updating documents:", error);
            toast.error("Grupaj Dökümanı güncelleme hatası");
        } finally {
            if (document.getElementById("save-button")) {
                document.getElementById("save-button").disabled = false
            }
        }
    };

    const truckValidate = () => {
        if (!formData.subcontractor_id) {
            toast.error('Taşıyıcı firma boş olamaz')
            return false
        }
        if (!formData.driver_name) {
            toast.error('Şöför adı boş olamaz')
            return false
        }

        // Phone number format validation (optional but must be valid if provided)
        if (formData.driver_phone.length > 0) {
            const phoneRegex = /^\(\d{3}\)\s\d{3}-\d{4}$/
            if (!phoneRegex.test(formData.driver_phone)) {
                toast.error('10 Haneli bir telefon numarası giriniz. Örn: 5XXXXXXXXX')
                return false
            }
        }

        if (!formData.plate_number) {
            toast.error('Plaka boş olamaz')
            return false
        }
        // License plate format validation (2 numbers + any letters + any numbers)
        const plateRegex = /^[0-9]{2}[A-Z]+[0-9]+$/
        if (!plateRegex.test(formData.plate_number)) {
            toast.error('Geçerli bir plaka formatı giriniz. Örn: 34ABC123')
            return false
        }

        return true
    }

    const handleTruckMatch = useCallback(async () => {
        if (!formData.driver_name || !formData.plate_number || !formData.subcontractor_id) {
            toast.error('Lütfen tüm alanları doldurun')
            return
        }

        try {
            setLoading(true)
            const response = await assignTruck({
                ...formData,
                groupage_no: groupageDetails.groupage_no
            })

            if (response.success === true) {
                // Taşıyıcı firma değişmiş olabilir, document'ı da güncelle
                try {
                    const documentBody = {
                        "groupage_no": groupageDetails?.groupage_no,
                        "paper": document.getElementById("matbuNo")?.value || groupageDetails?.paper || "",
                        "seri_no": document.getElementById("seriNo")?.value || groupageDetails?.serial_no || "",
                        "contractor_id": document.getElementById("kontrat-sahibi-warning") ? groupageDetails?.subcontractor_id : (document.getElementById("konrat-sahibi")?.childNodes[0]?.childNodes[0]?.value ? parseInt(document.getElementById("konrat-sahibi").childNodes[0].childNodes[0].value) : groupageDetails?.subcontractor_id),
                        "subcontractor_id": formData.subcontractor_id || null
                    }
                    await api.post("/updateDocuments", documentBody);
                } catch (docError) {
                    console.error("Document güncelleme hatası:", docError);
                    // Document güncelleme hatası olsa bile tır eşleme başarılı olduğu için devam et
                }

                toast.success('Tır eşleme işlemi başarılı')
                refreshData(false)
                // onFilter()
            } else {
                toast.error(response.message || 'Bir hata oluştu')
            }
        } catch (error) {
            console.error('Tır eşleme hatası:', error)
            toast.error('Tır eşleme işlemi başarısız')
        } finally {
            setLoading(false)
        }
    }, [formData, groupageDetails, refreshData])

    const handleCancelTruckMatch = useCallback(async () => {
        if (!groupageDetails?.groupage_no) return

        try {
            setLoading(true)
            const response = await cancelTruckAssignment({ groupage_no: groupageDetails.groupage_no })
            if (response.success === true) {
                toast.success('Tır eşleme iptali başarılı')
                refreshData(true)
                // onFilter()
            } else {
                toast.error(response.message || 'Bir hata oluştu')
            }
        } catch (error) {
            console.error('Tır eşleme iptal hatası:', error)
            toast.error('Tır eşleme iptali başarısız')
        } finally {
            setLoading(false)
        }
    }, [groupageDetails?.groupage_no, refreshData])

    const handleCancelGroupage = useCallback(async () => {
        try {
            setLoading(true)
            const response = await cancelGroupage({
                groupage_no: groupageDetails.groupage_no
            })
            if (response.status === "CANCELED") {
                toast.success('Grupaj bozma işlemi başarılı')
                detail()
                setIsOpen(prev => ({ ...prev, islemler: false }))
                onFilter()
            } else {
                toast.error(response.message || 'Bir hata oluştu')
            }
        } catch (error) {
            console.error('Grupaj bozma hatası:', error)
            toast.error('Grupaj bozma işlemi başarısız')
        } finally {
            setLoading(false)
        }
    }, [groupageDetails?.groupage_no, setIsOpen, onFilter])

    const handleApproveGroupage = useCallback(async () => {
        try {
            setLoading(true)
            const response = await approveGroupage({
                groupage_no: groupageDetails.groupage_no
            })
            if (response.status === "APPROVED") {
                toast.success('Grupaj onaylama işlemi başarılı')
                detail()
                // onFilter()
            } else {
                toast.error(response.message || 'Bir hata oluştu')
            }
        } catch (error) {
            console.error('Grupaj onaylama hatası:', error)
            toast.error('Grupaj onaylama işlemi başarısız')
        } finally {
            setLoading(false)
        }
    }, [groupageDetails?.groupage_no])

    const handleCancelApproval = useCallback(async () => {
        try {
            setLoading(true)
            const response = await cancelApproval({
                groupage_no: groupageDetails.groupage_no
            })
            if (response.success === true) {
                toast.success('Grupaj onay iptali başarılı')
                detail()
                // onFilter()
            } else {
                toast.error(response.message || 'Bir hata oluştu')
            }
        } catch (error) {
            console.error('Grupaj onay iptali hatası:', error)
            toast.error('Grupaj onay iptali başarısız')
        } finally {
            setLoading(false)
        }
    }, [groupageDetails?.groupage_no])

    const handleInputChange = useCallback((field) => (e) => {
        const value = e.target?.value ?? e.value

        if (field === 'driver_phone') {
            // Only allow numbers and format as phone number
            const phoneNumber = value.replace(/\D/g, '')
            if (phoneNumber.length <= 10) {
                const formattedPhone = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                setFormData(prev => ({ ...prev, [field]: formattedPhone }))
            }
        } else if (field === 'plate_number') {
            // Format as Turkish license plate: Number-Letters-Number
            const cleaned = value.replace(/[^0-9A-Za-z]/g, '').toUpperCase()
            let formatted = ''

            if (cleaned.length <= 2) {
                // First part (numbers only)
                const numbers = cleaned.replace(/[^0-9]/g, '')
                formatted = numbers
            } else {
                // Split into parts: first 2 numbers, then letters, then remaining numbers
                const firstPart = cleaned.slice(0, 2).replace(/[^0-9]/g, '')
                const remainingPart = cleaned.slice(2)
                const letters = remainingPart.replace(/[^A-Z]/g, '')
                const numbers = remainingPart.replace(/[^0-9]/g, '')

                formatted = firstPart + letters + numbers
            }

            setFormData(prev => ({ ...prev, [field]: formatted }))
        } else if (field === 'driver_name') {
            // Only allow letters, spaces, and Turkish characters
            const cleaned = value.replace(/[^a-zA-ZğüşıöçĞÜŞİÖÇ\s]/g, '')
            setFormData(prev => ({ ...prev, [field]: cleaned }))
        } else {
            setFormData(prev => ({ ...prev, [field]: value }))
        }
    }, [])

    const isTruckMatchDisabled = useMemo(() => (
        groupageDetails.plate_number !== undefined ||
        loading
    ), [groupageDetails?.plate_number, formData, loading])

    const isCancelMatchDisabled = useMemo(() => (
        !groupageDetails?.plate_number ||
        groupageDetails?.plate_number === "" ||
        loading
    ), [groupageDetails?.plate_number, loading])

    let allVehiclesExited = groupageDetails?.chassis_details?.every((item) => item.door_exit_date !== null && item.door_exit_date !== undefined && item.door_exit_date !== "")
    const CustomButton = ({ onClick, children, disabled }) => {
        return (
            <button className='mr-2' onClick={onClick}
                disabled={disabled ? disabled : false}
                style={{
                    backgroundColor: 'rgb(243, 243, 243)',
                    border: '1px solid rgb(221, 221, 221)',
                    padding: '8px 13px',
                }}>
                {children}
            </button>
        )
    }

    const inputStyle = {
        backgroundColor: 'rgb(255, 255, 255)',
        border: '1px solid rgb(221, 221, 221)',
        fontSize: '14px',
        lineHeight: '1.5',
        color: '#495057',
        height: '38px',
        '&:focus': {
            backgroundColor: 'rgb(255, 255, 255)',
            outline: 'none'
        }
    }

    const disabledStyle = {
        backgroundColor: '#e9ecef',
        opacity: 0.65,
        cursor: 'not-allowed'
    }
    if (groupageDetails.error) {
        setIsOpen(prev => ({ ...prev, islemler: false }))
        return <></>

    }

    return (
        <Modal
            isOpen={isOpen.islemler}
            // toggle={() => setIsOpen(prev => ({ ...prev, islemler: false }))}
            className="modal-dialog modal-xl"

            style={{
                maxWidth: "95%", width: "95vw", height: "95vh"
            }}
            position={{
                my: 'top',
                at: 'top',
                of: window,
                offset: '0 10',
            }}
        >
            <ModalHeader toggle={() => {
                onFilter()
                setIsOpen(prev => ({ ...prev, islemler: false }))
            }} >
                <h5>Grupaj İşlemleri</h5>
            </ModalHeader>


            {
                groupageDetails?.chassis_details === undefined ?

                    <div className="d-flex justify-content-center align-items-center h-100" style={{ minHeight: "50vh" }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                    :

                    <ModalBody>
                        <Row className='mb-1 mt-2 w-100'>
                            <Col md="1" >
                                {
                                    groupageDetails.is_editable ? (
                                        saseEklemeRole &&
                                        !groupageDetails?.groupage_no?.startsWith('D') && (
                                            <CustomButton
                                                onClick={handleAddPopupOpen}
                                            >
                                                <i class="fa fa-plus" aria-hidden="true" />   Şase Ekle
                                            </CustomButton>
                                        )
                                    ) : (
                                        <Col md="1"> </Col>
                                    )
                                }
                            </Col>
                            {groupageDetails.is_editable ? (
                                <Col md="4">
                                    <CustomButton
                                        onClick={handleCancelGroupage}
                                        disabled={loading || groupageDetails?.status === "APPROVED" || groupageDetails?.status === "CANCELED" || allVehiclesExited}
                                        className='mr-2'
                                    >
                                        <i className="fa fa-window-restore me-2" /> &nbsp;
                                        Grupaj Boz
                                    </CustomButton>
                                    <CustomButton
                                        onClick={handleApproveGroupage}
                                        disabled={loading || groupageDetails?.status === "APPROVED" || groupageDetails?.status === "CANCELED" || allVehiclesExited}
                                        className='mr-2'
                                    >
                                        <i className="fa fa-check me-2" /> &nbsp;
                                        Grupaj Onayla
                                    </CustomButton>

                                    <CustomButton
                                        onClick={handleCancelApproval}
                                        disabled={loading || groupageDetails?.status !== "APPROVED" || groupageDetails?.status === "CANCELED" || allVehiclesExited}
                                    >
                                        <i className="fa fa-times me-2" /> &nbsp;
                                        Onay İptal
                                    </CustomButton>
                                </Col>
                            ) : (
                                <Col md="4">
                                    <span className='text-danger'>*HAL Entegrasyonu ile alınan grupaj, düzenlenemez.</span>
                                </Col>
                            )}
                            {true ? (
                                <Col md="3">
                                    <CustomButton
                                        onClick={() => {
                                            if (truckValidate()) handleTruckMatch()
                                        }}
                                        disabled={isTruckMatchDisabled}
                                        className='mr-2'
                                    >
                                        <i className="fa fa-truck me-2" /> &nbsp; Tır Eşle
                                    </CustomButton>
                                    <CustomButton
                                        onClick={handleCancelTruckMatch}
                                        disabled={isCancelMatchDisabled}
                                    >
                                        <i className="fa fa-times me-2" />  &nbsp;Tır Eşle İptal
                                    </CustomButton>
                                </Col>
                            ) : (
                                <Col md="3"> </Col>
                            )}

                            <Col md="2">
                                <CustomButton
                                    onClick={() => {
                                        const selectedRows = groupageRef.current.instance.getSelectedRowKeys();
                                        Grupaj(groupageDetails, selectedRows);
                                    }}
                                    className='mr-2'><i className='fa fa-print text-xl mb-1' /> &nbsp;Yazdır</CustomButton>
                                <CustomButton
                                    onClick={(e) => {
                                        onFilter()
                                        setIsOpen({ ...isOpen, islemler: false })
                                    }}
                                > <i className="fa fa-times me-2" />&nbsp; KAPAT</CustomButton>
                            </Col>
                        </Row>
                        <Row className='mb-1 mt-2 w-100'>
                            <Col md="12" style={{ minHeight: "100px" }}>
                                <DataGrid
                                    dataSource={groupageDetails?.chassis_details}
                                    id='gridContainer-custom'
                                    showBorders={true}
                                    showRowLines={true}
                                    showColumnLines={true}
                                    allowColumnResizing={true}
                                    onCellPrepared={(e) => {
                                        // if (e.data && e.data.priority) {

                                        // }
                                        if (e.rowType === "data" && e.column.dataField === "priority" && e.data.priority !== null) {
                                            e.cellElement.style.backgroundColor = "red";
                                            e.cellElement.style.color = "white";
                                            e.cellElement.style.fontWeight = "bold";
                                        }
                                    }}
                                >
                                    <Column caption='Grupaj No' dataField='groupage_no' alignment='center' calculateDisplayValue={() => groupageDetails.groupage_no} width={125} />
                                    <Column caption='Şase' dataField='chassis_no' alignment='center' width={150} />
                                    <Column caption='Öncelik' dataField='priority' alignment='center' width={70} />
                                    <Column caption='Model Adı' dataField='model' alignment='center' width={125} />
                                    <Column caption='Renk Adı' dataField='color' alignment='center' width={155} />
                                    <Column caption='Nereden' dataField='exit_warehouse' alignment='center' width={170} />
                                    <Column caption='Nereye' dataField='target' alignment='center' calculateDisplayValue={(row) => row.target + " - " + row.city_name + " / " + row.district_name} />
                                    <Column
                                        caption='Grupaj Peronu'
                                        dataField='groupage_peron'
                                        alignment='center'
                                        width={150}
                                        cellRender={(e) => {
                                            return (
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    width: '100%'
                                                }}>
                                                    <span>{e.data.groupage_peron || ''}</span>
                                                    {e.data.loading_dock && (
                                                        <span style={{
                                                            marginLeft: 'auto',
                                                            fontWeight: '500'
                                                        }}>
                                                            {e.data.loading_dock}
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        }}
                                    />
                                    <Column caption='Stok Adresi' dataField='park_address' alignment='center' width={"auto"} />
                                    <Column caption='PDI' dataField='pdi_status' alignment='center' width={50} />
                                    {
                                        groupageDetails.is_editable &&
                                        saseCikarmaRole &&
                                        <Column
                                            caption='Çıkart'
                                            alignment='center'
                                            width={85}
                                            cellRender={(e) => {
                                                const isDisabled = e.data.park_address?.startsWith("SANAL / XX-1");

                                                return (
                                                    <Button
                                                        style={{
                                                            width: "65px",
                                                            padding: "4px 6px",
                                                            textAlign: "center",
                                                            fontSize: "12px", // Eğer taşma varsa küçültme faydalı olur
                                                            whiteSpace: "nowrap", // taşmayı engeller
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }}
                                                        color="danger"
                                                        disabled={isDisabled}
                                                        onClick={() => handleDeletePopupOpen(e.data)}
                                                    >
                                                        ÇIKART
                                                    </Button>
                                                );
                                            }}
                                        />}

                                </DataGrid>
                            </Col>
                        </Row>
                        <hr />
                        <Row className='mt-2 mb-1 w-100 tir-esle-grupaj-islemler'>

                            <Col md="6" className='ml-2'>
                                <FormGroup className='row'>
                                    <Label style={{ fontWeight: "bold", textAlign: "left" }} for='shipping_date' className='col-md-3' >Sevk Tarihi: &emsp; </Label>
                                    <DateBox
                                        className='col-md-8 p-0'
                                        id='shipping_date'
                                        defaultValue={
                                            groupageDetails?.shipping_date ? groupageDetails?.shipping_date.split(" ")[0] : null
                                        }
                                        type='date'
                                        displayFormat='dd.MM.yyyy'
                                        style={{
                                            ...inputStyle,
                                            padding: '6px 12px'
                                        }}
                                    />
                                </FormGroup>
                                <FormGroup className='row'>
                                    <Label style={{ fontWeight: "bold", textAlign: "left" }} for='contract_owner' className='col-md-3' >Kontrat Sahibi: &emsp; </Label>
                                    <>
                                        <SelectBox
                                            className='col-md-8'
                                            style={{
                                                ...inputStyle,
                                                padding: '6px 12px',
                                                position: 'relative'
                                            }}
                                            id='konrat-sahibi'
                                            displayExpr="name"
                                            valueExpr="id"
                                            defaultValue={groupageDetails?.subcontractor_id || null}
                                            dataSource={_.uniqBy(contractData, "id")}
                                        />
                                        {
                                            !(_.uniqBy(contractData, "id").some(item => item.id === groupageDetails?.subcontractor_id)) ?

                                                <div
                                                    id='kontrat-sahibi-warning'
                                                    className=""
                                                    style={{
                                                        border: 'none',
                                                        borderLeft: '3px solid #dc3545',
                                                        padding: '8px 12px',
                                                        marginLeft: '10px',
                                                        marginTop: '4px',
                                                        fontSize: '13px',
                                                        color: 'rgb(0 0 0)',
                                                        fontWeight: '400',
                                                        lineHeight: '1.4',
                                                        borderRadius: '0 4px 4px 0'
                                                    }}>
                                                    <i className='fa fa-exclamation-triangle mr-2' style={{ color: "#dc3545", fontSize: '13px' }} />
                                                    <strong style={{ color: '#dc3545' }}>Bilgi:</strong> Bu grupajın mevcut kontrat sahibi <strong style={{ color: '#dc3545' }}>"{groupageDetails?.subcontractor_name}"</strong> firmasıdır. Bu firma mevcut kontrat sahibi listesinde bulunmamaktadır. Eğer bu alanı boş bırakırsanız, herhangi bir değişiklik yapılmayacaktır.
                                                </div> : null

                                        }
                                    </>
                                </FormGroup>
                                <hr />
                                <FormGroup className='row'>
                                    <Label style={{ fontWeight: "bold", textAlign: "left" }} for='tasiyici-firma' className='col-md-3' >Taşıyıcı Firma: &emsp; </Label>
                                    <SelectBox
                                        disabled={Boolean(groupageDetails?.plate_number)}
                                        style={{
                                            ...inputStyle,
                                            ...(groupageDetails?.plate_number ? disabledStyle : {}),
                                            padding: '6px 12px'
                                        }}
                                        className='col-md-8'
                                        id='tasiyici-firma'
                                        displayExpr="name"
                                        valueExpr="id"
                                        value={formData.subcontractor_id}
                                        dataSource={_.uniqBy(taseronData, "id")}
                                        onValueChanged={(e) => handleInputChange('subcontractor_id')(e)}
                                    />
                                </FormGroup>
                                <FormGroup className='row'>
                                    <Label style={{ fontWeight: "bold", textAlign: "left" }} for='sofor-adi' className='col-md-3' >Şöför Adı: &emsp; </Label>
                                    <Input
                                        disabled={Boolean(groupageDetails?.plate_number)}
                                        className='col-md-8 custom-input'
                                        id='sofor-adi'
                                        value={formData.driver_name}
                                        onChange={handleInputChange('driver_name')}
                                        autoComplete="name"
                                        name="driver_name"
                                    />
                                </FormGroup>
                                <FormGroup className='row'>
                                    <Label style={{ fontWeight: "bold", textAlign: "left" }} for='sofor-telefon' className='col-md-3' >Şöför Telefon: &emsp; </Label>
                                    <Input
                                        disabled={Boolean(groupageDetails?.plate_number)}
                                        className='col-md-8 custom-input'
                                        id='sofor-telefon'
                                        value={formData.driver_phone?.replace("(___)___ __ __", "")}
                                        onChange={handleInputChange('driver_phone')}
                                        placeholder="Örn: 5XXXXXXXXX"
                                        autoComplete="tel"
                                        name="driver_phone"
                                    />
                                </FormGroup>
                                <FormGroup className='row'>
                                    <Label style={{ fontWeight: "bold", textAlign: "left" }} for='plaka' className='col-md-3' >Plaka / Dorse: &emsp; </Label>
                                    <div className='col-md-8' style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: "0",
                                        gap: '10px'
                                    }}>
                                        <Input
                                            disabled={Boolean(groupageDetails?.plate_number)}
                                            id='plaka'
                                            className='custom-input'
                                            value={formData.plate_number}
                                            onChange={handleInputChange('plate_number')}
                                            placeholder="Örn: 34ABC123"
                                            style={{
                                                ...(groupageDetails?.plate_number ? disabledStyle : {}),
                                                flex: 1
                                            }}
                                            autoComplete="on"
                                            name="plate_number"
                                        />
                                        <Input
                                            disabled={Boolean(groupageDetails?.plate_number)}
                                            id='dorse'
                                            className='custom-input'
                                            value={formData.trailer_plate}
                                            onChange={handleInputChange('trailer_plate')}
                                            placeholder="Dorse No"
                                            style={{
                                                ...(groupageDetails?.plate_number ? disabledStyle : {}),
                                                flex: 1
                                            }}
                                            autoComplete="on"
                                            name="trailer_plate"
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>


            }
            {
                groupageDetails?.chassis_details !== undefined &&
                <ModalFooter
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center'

                    }}
                >
                    <Row className='w-50'>
                        <Col md="12">
                            <FormGroup className='row'>
                                <Label style={{ fontWeight: "bold", textAlign: "left" }} className='col-md-3'> Matbu / Seri No : &emsp; </Label>
                                <div className='col-md-8' style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: "0"
                                }}>
                                    <Input className='mr-1 custom-input' id='matbuNo' defaultValue={groupageDetails?.paper} />
                                    <Input className='custom-input' id='seriNo' defaultValue={groupageDetails?.serial_no} />
                                </div>
                            </FormGroup>
                        </Col>
                        <Col md="12"
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                gap: '10px'
                            }}
                        >
                            <Button
                                onClick={handleSave}
                                id='save-button'
                                color='primary'
                                style={{ height: "100%" }}
                            >Kaydet</Button>
                            {/* <Button
                                color='secondary'
                            >
                                <i className="fa fa-print me-2" /> &nbsp; İrsaliye Oluştur
                            </Button> */}
                            <Irsaliye data={groupageDetails} text="İrsaliye Yazdır" />
                        </Col>
                    </Row>

                </ModalFooter>
            }
            <IslemlerSilmePopup
                isOpen={modalOpen.deleteModalOpen}
                toggle={handlePopupClose}
                chassis={selectedChassis}
                groupage={groupageDetails}
                refreshData={detail}
                onGroupageEmpty={handleGroupageEmpty}
            />
            <IslemlerEklePopup
                isOpen={modalOpen.addModalOpen}
                toggle={handlePopupClose}
                refreshData={detail}
                groupageNo={groupageDetails?.groupage_no}
            />

        </Modal >
    )
}

export default React.memo(IslemlerPopup)